import { render } from "./SortTableAbsenceStatusComponent.vue?vue&type=template&id=4e4953f0&scoped=true"
import script from "./SortTableAbsenceStatusComponent.vue?vue&type=script&lang=js"
export * from "./SortTableAbsenceStatusComponent.vue?vue&type=script&lang=js"

import "./SortTableAbsenceStatusComponent.vue?vue&type=style&index=0&id=4e4953f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4953f0"]])

export default __exports__